(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var scrim = document.querySelector('[data-cdraw-scrim]');
  var linesEl = drawer.querySelector('[data-cdraw-lines]');
  var shipEl = drawer.querySelector('[data-cdraw-ship]');
  var fillEl = drawer.querySelector('[data-cdraw-ship-fill]');
  var hintEl = drawer.querySelector('[data-cdraw-ship-hint]');
  var trackEl = drawer.querySelector('[role="progressbar"]');
  var subtotalEl = drawer.querySelector('[data-cdraw-subtotal]');
  var recsWrap = drawer.querySelector('[data-cdraw-recs]');
  var recsList = drawer.querySelector('[data-cdraw-recs-list]');
  var sideEl = drawer.querySelector('[data-cdraw-side]');
  var sideList = drawer.querySelector('[data-cdraw-side-list]');
  var emptyEl = drawer.querySelector('[data-cdraw-empty]');
  var titleEl = drawer.querySelector('#bg-cdraw-title');
  var promoForm = drawer.querySelector('[data-cdraw-promo-form]');
  var promoInput = drawer.querySelector('[data-cdraw-promo-input]');
  var promoMsg = drawer.querySelector('[data-cdraw-promo-msg]');
  var codesEl = drawer.querySelector('[data-cdraw-codes]');
  var sumsEl = drawer.querySelector('[data-cdraw-sums]');
  var itemsEl = drawer.querySelector('[data-cdraw-items]');
  var discEl = drawer.querySelector('[data-cdraw-disc]');
  var THRESHOLD = parseInt(drawer.dataset.threshold, 10) || 0;
  var SHIP = parseInt(drawer.dataset.shipping, 10) || 0;
  var discRow = drawer.querySelector('[data-cdraw-discrow]');
  var shipRow = drawer.querySelector('[data-cdraw-shiprow]');
  var shipCostEl = drawer.querySelector('[data-cdraw-shipcost]');
  var errEl = drawer.querySelector('[data-cdraw-error]');

  var lastFocus = null;

  var sample = drawer.dataset.moneySample || '0.00';
  var moneyParts = sample.match(/^(.*?)(\d[\d.,'’   ]*\d|\d)(.*)$/) || [null, '', '0.00', ''];
  var moneyPre = moneyParts[1];
  var moneyPost = moneyParts[3];
  var decMark = moneyParts[2].length > 2 ? moneyParts[2].charAt(moneyParts[2].length - 3) : '.';

  function money(cents) {
    return moneyPre + (cents / 100).toFixed(2).replace('.', decMark) + moneyPost;
  }

  var L = {
    dec: drawer.dataset.labelDecrease || '-',
    inc: drawer.dataset.labelIncrease || '+',
    rm: drawer.dataset.labelRemove || '',
    qty: drawer.dataset.labelQty || '',
  };
  function fill(tpl, title) { return String(tpl || '').replace('__TITLE__', title || ''); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function setMode(mode) {
    if (!titleEl) return;
    var t = mode === 'added' ? drawer.dataset.titleAdded : drawer.dataset.titleCart;
    if (t) titleEl.textContent = t;
  }

  function setEmpty(isEmpty) {
    drawer.classList.toggle('is-empty', !!isEmpty);
    if (emptyEl) emptyEl.hidden = !isEmpty;
    if (isEmpty) setMode('cart');
  }

  function open() {
    lastFocus = document.activeElement;
    scrim.hidden = false;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      scrim.classList.add('is-open');
      drawer.classList.add('is-open');
    });
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('bg-cdraw-open');
    var first = drawer.querySelector('[data-cdraw-close]');
    if (first) first.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    scrim.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('bg-cdraw-open');
    document.removeEventListener('keydown', onKey);
    window.setTimeout(function () {
      drawer.hidden = true;
      scrim.hidden = true;
    }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function renderLines(cart, addedKey) {
    setEmpty(!cart.items || !cart.items.length);
    if (!cart.items || !cart.items.length) { linesEl.innerHTML = ''; return; }
    linesEl.innerHTML = cart.items.map(function (it, idx) {
      var isAdded = addedKey && it.key === addedKey;
      var title = it.product_title || it.title;
      var href = esc(it.url || '#');
      var img = it.image
        ? '<a class="bg-cdraw-line-img" href="' + href + '"><img src="' + esc(it.image) + '" alt="" width="66" height="66"></a>'
        : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title'
        ? '<div class="bg-cdraw-line-meta">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="bg-cdraw-line' + (isAdded ? ' is-added' : '') + '" data-cdraw-line="' + (idx + 1) + '">' + img +
        '<div class="bg-cdraw-line-mid">' +
        '<a class="bg-cdraw-line-name" href="' + href + '">' + esc(it.product_title || it.title) + '</a>' +
        variant +
        '<div class="bg-cdraw-line-price">' + money(it.final_line_price != null ? it.final_line_price : it.line_price) + '</div>' +
        '</div>' +
        '<div class="bg-cdraw-qty">' +
          '<button type="button" class="bg-cdraw-step" data-cdraw-step="-1" aria-label="' + esc(it.quantity <= 1 ? fill(L.rm, title) : L.dec) + '">' +
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>' +
          '</button>' +
          '<input type="number" class="bg-cdraw-qtyinput" data-cdraw-qty value="' + it.quantity + '" min="0" inputmode="numeric" aria-label="' + esc(fill(L.qty, title)) + '">' +
          '<button type="button" class="bg-cdraw-step" data-cdraw-step="1" aria-label="' + esc(L.inc) + '">' +
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>' +
          '</button>' +
        '</div>' +
        '</div>';
    }).join('');
  }

  function renderShipping(cart) {
    if (!THRESHOLD) { shipEl.hidden = true; return; }
    var remaining = THRESHOLD - cart.total_price;
    var pct = Math.max(0, Math.min(100, Math.round((cart.total_price / THRESHOLD) * 100)));
    fillEl.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0 round 999px)';
    if (trackEl) trackEl.setAttribute('aria-valuenow', String(pct));
    if (remaining <= 0) {
      shipEl.classList.add('is-unlocked');
      hintEl.innerHTML = '<span class="gf-stamp">' + esc(drawer.dataset.freeStamp || drawer.dataset.unlocked || '') + '</span>';
    } else {
      shipEl.classList.remove('is-unlocked');
      hintEl.innerHTML = (drawer.dataset.remaining || '__AMOUNT__')
        .replace('__AMOUNT__', money(remaining));
    }
  }

  function updateBadge(count) {
    var link = document.querySelector('a[href$="/cart"], .bg-icon-cart');
    if (!link) return;
    var badge = link.querySelector('.bg-cart-badge');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'bg-cart-badge';
        link.appendChild(badge);
      }
      badge.textContent = String(count);
    } else if (badge) {
      badge.remove();
    }
  }

  var fallback = [];
  try {
    var fbEl = drawer.querySelector('[data-cdraw-fallback]');
    if (fbEl) fallback = JSON.parse(fbEl.textContent) || [];
  } catch (e) { fallback = []; }

  function recHtml(p) {
    var img = p.image ? '<a class="bg-cdraw-rec-img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(p.image) + '" alt="" width="52" height="52" loading="lazy"></a>' : '';
    return '<div class="bg-cdraw-rec">' + img +
      '<div class="bg-cdraw-rec-mid">' +
      '<a class="bg-cdraw-rec-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="bg-cdraw-rec-price">' + money(p.price) + '</div>' +
      '</div>' +
      '<button type="button" class="bg-cdraw-rec-add" data-rec-add="' + esc(p.variant) + '" aria-label="' + esc(fill(drawer.dataset.labelAdd, p.title)) + '">' + esc(drawer.dataset.addWord || '+') + '</button>' +
      '</div>';
  }

  function sideHtml(p) {
    var img = p.image ? '<a class="bg-cdraw-sitem-img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(p.image) + '" alt="" width="96" height="96" loading="lazy"></a>' : '<span></span>';
    return '<div class="bg-cdraw-sitem">' + img +
      '<div>' +
      '<a class="bg-cdraw-sitem-name" href="' + esc(p.url) + '">' + esc(String(p.title).split(' (')[0]) + '</a>' +
      '<div class="bg-cdraw-sitem-price">' + money(p.price) + '</div>' +
      '<button type="button" class="bg-cdraw-sitem-add" data-rec-add="' + esc(p.variant) + '" aria-label="' + esc(fill(drawer.dataset.labelAdd, p.title)) + '">' + esc(drawer.dataset.addWord || '+') +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h15M14 6.5l5.5 5.5L14 17.5"/></svg>' +
      '</button>' +
      '</div>' +
      '</div>';
  }

  function showRecs(list) {
    recsList.innerHTML = list.slice(0, 3).map(recHtml).join('');
    recsWrap.hidden = !recsList.innerHTML.trim();
    if (sideList) {
      sideList.innerHTML = list.slice(0, 4).map(sideHtml).join('');
      var has = !!sideList.innerHTML.trim();
      sideEl.hidden = !has;
      drawer.classList.toggle('has-side', has);
    }
  }

  function sized(u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=240' : u; }
  function firstProduct(cart) { return cart && cart.items && cart.items.length ? cart.items[0].product_id : null; }

  function renderRecs(productId, cart) {
    if (!recsWrap) return;
    var inCart = {};
    ((cart && cart.items) || []).forEach(function (it) { inCart[String(it.product_id)] = true; });
    if (productId) inCart[String(productId)] = true;
    function useFallback() {
      showRecs(fallback.filter(function (p) { return !inCart[String(p.id)]; }));
    }
    if (!productId) { useFallback(); return; }
    fetch(ROOT + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=4&intent=related')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var list = ((data && data.products) || []).filter(function (p) {
          var v = (p.variants || [])[0];
          return v && v.available && !inCart[String(p.id)];
        }).map(function (p) {
          return { id: p.id, title: p.title, url: p.url, image: sized(p.featured_image), price: p.variants[0].price, variant: p.variants[0].id };
        });
        if (list.length) showRecs(list); else useFallback();
      })
      .catch(useFallback);
  }

  function renderTotals(cart) {
    var lines = 0;
    (cart.items || []).forEach(function (it) { lines += it.final_line_price != null ? it.final_line_price : it.line_price; });
    var off = lines - cart.total_price;
    var showShip = SHIP > 0 && !!(cart.items && cart.items.length);
    var ship = showShip && !(THRESHOLD && cart.total_price >= THRESHOLD) ? SHIP : 0;
    if (sumsEl) {
      sumsEl.hidden = off <= 0 && !showShip;
      itemsEl.textContent = money(lines);
      if (discRow) discRow.hidden = off <= 0;
      if (off > 0) discEl.textContent = '−' + money(off);
      if (shipRow) {
        shipRow.hidden = !showShip;
        shipRow.classList.toggle('is-free', showShip && ship === 0);
        shipCostEl.textContent = ship === 0 ? (drawer.dataset.freeLabel || money(0)) : money(ship);
      }
    }
    subtotalEl.textContent = money(cart.total_price + ship);
    renderCodes(cart);
  }

  function appliedCodes(cart) {
    return ((cart && cart.discount_codes) || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
  }

  function renderCodes(cart) {
    if (!codesEl) return;
    var codes = appliedCodes(cart);
    codesEl.hidden = !codes.length;
    codesEl.innerHTML = codes.map(function (c) {
      var label = String(drawer.dataset.discountRemove || '').replace('__CODE__', c);
      return '<li class="bg-cdraw-code">' + esc(c) +
        '<button type="button" class="bg-cdraw-code-x" data-cdraw-code-remove="' + esc(c) + '" aria-label="' + esc(label) + '">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button></li>';
    }).join('');
  }

  function say(text) {
    if (!promoMsg) return;
    promoMsg.textContent = text || '';
    promoMsg.hidden = !text;
  }

  function setCodes(list) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: list.join(',') }),
    }).then(function (r) {
      if (!r.ok) throw new Error('discount ' + r.status);
      return r.json();
    });
  }

  function paint(cart) {
    drawer.classList.add('has-cart');
    renderLines(cart, null);
    renderShipping(cart);
    renderTotals(cart);
    updateBadge(cart.item_count);
  }

  function applyCode(code, current) {
    var key = code.toLowerCase();
    var keep = current.filter(function (c) { return c.toLowerCase() !== key; });
    var wrap = promoForm && promoForm.parentNode;
    if (wrap) wrap.classList.add('is-busy');
    say('');
    return setCodes(keep.concat([code]))
      .then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === key; })[0];
        if (hit && hit.applicable) { promoInput.value = ''; return cart; }
        say(String(drawer.dataset.discountInvalid || '').replace('__CODE__', code));
        return setCodes(appliedCodes(cart).filter(function (c) { return c.toLowerCase() !== key; }));
      })
      .then(paint)
      .catch(function () { say(drawer.dataset.discountError || ''); })
      .then(function () { if (wrap) wrap.classList.remove('is-busy'); });
  }

  function currentCodes() {
    return Array.prototype.map.call(codesEl ? codesEl.querySelectorAll('[data-cdraw-code-remove]') : [], function (b) {
      return b.getAttribute('data-cdraw-code-remove');
    });
  }

  if (promoForm) {
    promoForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = promoInput.value.trim();
      if (code) applyCode(code, currentCodes());
    });
    promoInput.addEventListener('input', function () { say(''); });
  }

  drawer.addEventListener('click', function (e) {
    var x = e.target.closest('[data-cdraw-code-remove]');
    if (!x) return;
    var gone = x.getAttribute('data-cdraw-code-remove').toLowerCase();
    say('');
    setCodes(currentCodes().filter(function (c) { return c.toLowerCase() !== gone; }))
      .then(paint)
      .catch(function () { say(drawer.dataset.discountError || ''); });
  });

  function refresh(addedItem, productId) {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        drawer.classList.add('has-cart');
        if (errEl) errEl.hidden = true;
        renderLines(cart, addedItem && addedItem.key);
        renderShipping(cart);
        renderTotals(cart);
        updateBadge(cart.item_count);
        renderRecs(productId || firstProduct(cart), cart);
        return cart;
      });
  }

  function addToCart(body) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: body,
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed ' + r.status);
      return r.json();
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    addToCart(new FormData(form))
      .then(function (added) {
        var item = added.items ? added.items[0] : added;
        setMode('added');
        return refresh(item, item && item.product_id);
      })
      .then(open)
      .catch(function () { form.submit(); })
      .then(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
      });
  });

  function changeLine(lineEl, quantity) {
    if (!lineEl) return;
    var line = parseInt(lineEl.dataset.cdrawLine, 10);
    if (!line) return;
    lineEl.classList.add('is-busy');
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paint(cart);
        renderRecs(firstProduct(cart), cart);
      })
      .catch(function () { lineEl.classList.remove('is-busy'); });
  }

  drawer.addEventListener('click', function (e) {
    var step = e.target.closest('[data-cdraw-step]');
    if (step) {
      var lineEl = step.closest('[data-cdraw-line]');
      var input = lineEl && lineEl.querySelector('[data-cdraw-qty]');
      if (input) changeLine(lineEl, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.cdrawStep, 10));
      return;
    }
  });

  drawer.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cdraw-qty]');
    if (!input) return;
    changeLine(input.closest('[data-cdraw-line]'), parseInt(input.value, 10) || 0);
  });

  drawer.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rec-add]');
    if (!b) return;
    b.disabled = true;
    var fd = new FormData();
    fd.append('id', b.getAttribute('data-rec-add'));
    fd.append('quantity', '1');
    addToCart(fd)
      .then(function (added) {
        var item = added.items ? added.items[0] : added;
        return refresh(item, item && item.product_id);
      })
      .catch(function () { b.disabled = false; });
  });

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cdraw-close]')) close();
  });

  function openFromIcon() {
    setMode('cart');
    if (errEl) errEl.hidden = true;
    drawer.classList.remove('is-failed');
    drawer.classList.add('is-loading');
    if (!drawer.classList.contains('is-open')) open();
    var tries = 0;
    (function load() {
      refresh(null, null)
        .then(function () { drawer.classList.remove('is-loading'); })
        .catch(function () {
          if (++tries < 2) { window.setTimeout(load, 700); return; }
          drawer.classList.remove('is-loading');
          drawer.classList.add('is-failed');
          if (errEl) errEl.hidden = false;
        });
    })();
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.bg-icon-cart');
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (document.querySelector('[data-cart-root]')) return;
    e.preventDefault();
    openFromIcon();
  });
  scrim.addEventListener('click', close);

  window.bgCdrawReady = true;
  if (window.bgCdrawPending) {
    window.bgCdrawPending = false;
    if (document.querySelector('[data-cart-root]')) window.location.reload();
    else openFromIcon();
  }
})();
